/**
 * Shared Explore bank-filter apply / clear path.
 * Search (Bank group pick) and map bank-label taps must stay identical.
 */

export type BankFilterSlotCommands = {
  SetSearchMode: (isSearchMode: boolean) => void;
  SelectBankFilter: (bankFilter: boolean) => void;
  SelectedSlotsName: (slotName: string) => void;
  SelectedSlots: (selectedSlots: string[]) => void;
  ClearSelectedSlots: () => void;
};

export type BankFilterCompareCommands = {
  setSlotNumbers: (state: { slotNumbers: number[] }) => void;
  clearSlots: () => void;
};

/** Ensure chip text is "Bank <label>" without double-prefixing. */
export function bankFilterDisplayName(label: string): string {
  const raw = String(label ?? '').trim();
  if (!raw) return 'Bank';
  if (/^Bank\b/i.test(raw)) return raw.replace(/^Floor Location\b/i, 'Bank Location').replace(/^Floor\b/i, 'Bank');
  return `Bank ${raw}`;
}

/**
 * Apply a bank filter exactly like choosing "Bank 9G (n)" in search:
 * search mode on, bank flag on, name, mnums, compare list cleared.
 */
export function applyBankFilter(
  slotCommands: BankFilterSlotCommands,
  compareCommands: BankFilterCompareCommands,
  label: string,
  mnums: string[]
): void {
  const displayName = bankFilterDisplayName(label);
  slotCommands.SetSearchMode(true);
  slotCommands.SelectBankFilter(true);
  slotCommands.SelectedSlotsName(displayName);
  slotCommands.SelectedSlots(mnums.map(String));
  compareCommands.setSlotNumbers({ slotNumbers: [] });
}

/**
 * Clear the bank filter the same way as the RemovableTag chip X.
 */
export function clearBankFilter(
  slotCommands: BankFilterSlotCommands,
  compareCommands: BankFilterCompareCommands
): void {
  slotCommands.ClearSelectedSlots();
  slotCommands.SelectBankFilter(false);
  compareCommands.clearSlots();
}
